export default __webpack_public_path__ + "static/media/what-is-it.728f55f6.png";